import { gql } from '@apollo/client';

export default gql`
  query me {
    me {
      username
      email
      salesChannel
      fullName
      productFamilies {
        name
        code
      }
      productFamiliesAccessibleTravel {
        name
        code
      }
      organization {
        code
      }
      discountCards {
        name
        code
      }
      paymentCurrencies
      canEditPassengers @client
      canHaveGroupBookings @client
      canHaveStandardBookings @client
      canHaveAccessibleTravelBookings
      canOverrideFees @client
      canOverrideRules @client
      canSellExtrasOnlyBookings
      canSellPackageBookings
      paymentLocation @client
      canAddSpecialAssistanceToBooking
      accessToken
      passwordExpiry
      contracts {
        name
        code
      }
      offices {
        name
        description
        defaultPaymentLocation
        isStation
      }
      agentRoles
      isStation @client
      afterSalesShortcuts
      allowAfterSalesOverrideRules
      permissions
      defaultJourneyOrigin
      defaultJourneyDestination
      allowAfterSalesCancel
      allowedVoucherCreationTypes
      allowedVoucherRedemptionTypes
      canEnableVouchers
      canDisableVouchers
      canCreateVouchers @client
      canUpdateVouchers
      canRetrieveVouchers
      canManageVouchers @client
      canManageGenerateBulkVouchers @client
      canManageProcessBulkVouchers @client
      canManageClubEurostar
      isReadOnly
      canSellTravelPass
      canGenerateSilverVoucher
      canEnableSilverVoucher
      canDisableSilverVoucher
    }
  }
`;
